module.exports = __webpack_public_path__ + "img/palyazat_kutatas_hatter.11a2674e.png";